import { offerings } from '../services/bff.api';

export const OFFERINGS_RESOURCE = {
  key: 'OFFERINGS_RESOURCE',
  table: {
    defaultSort: 'title',
    dataLocation: '_embedded.offerings',
    searchParams: ['search']
  },
  single: {
    public: true,
    dataTransform: (data) => ({
      ...data,
      images: data?.imageUrls ?? []
    })
  },
  api: {
    get: offerings.search,
    getById: (id) => offerings.getById(id)
  }
};
